import { normalizeItem } from './normalizeItem';

export const normalizeItems: any = (data: any, id: string, name: string): any =>
  data.map((itm: any, index: number) => normalizeItem(itm, id, name, index));
